import React from 'react';
import { ArrowRight } from 'lucide-react';
import { useLanguage } from '../context/LanguageContext';
import { useContactModal } from '../context/ContactModalContext';
import { t } from '../data/translations';

const HeroSection = () => {
  const { language } = useLanguage();
  const { openContactModal } = useContactModal();

  return (
    <section 
      className="relative min-h-screen pt-24 overflow-hidden"
      style={{ backgroundColor: '#e8a238' }}
    >
      {/* 3D Character Video */}
      <div 
        className="absolute bottom-[-250px] right-[5%] w-[630px] h-[870px] md:w-[750px] md:h-[1020px] pointer-events-none"
        style={{ clipPath: 'inset(35px 30px 50px 35px)' }}
      >
        <video
          src="https://framerusercontent.com/assets/27Zn1jl933zbwV3WIcXOQDLiZMM.mp4"
          autoPlay
          loop
          muted
          playsInline
          preload="auto"
          className="w-full h-full object-contain"
          poster="https://framerusercontent.com/images/GPOhlopdzVcApwPQmU3Lfuq17EE.png"
        />
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-6 py-16 md:py-32">
        <div className="max-w-xl">
          {/* Badge */}
          <div className="inline-flex items-center gap-3 mb-8 flex-wrap">
            <span className="px-4 py-1.5 bg-[#0C39C8] text-white text-sm font-medium rounded-full">
              {t('hero.badge', language)}
            </span>
            <span className="text-[#131132] font-medium">{t('hero.badgeText', language)}</span>
            <a href="#news" className="text-[#131132] font-medium underline hover:opacity-80 transition-opacity">
              {t('hero.readMore', language)} &gt;
            </a>
          </div>

          {/* Headline */}
          <h1 className="text-5xl md:text-[57px] font-medium text-[#131132] leading-[0.9] mb-6">
            {t('hero.headline', language)}
          </h1>

          {/* Description */}
          <p className="text-lg text-[#131132] mb-8 max-w-lg leading-relaxed font-medium">
            {t('hero.description', language)}
          </p>

          {/* CTA Button */}
          <button
            onClick={openContactModal}
            className="inline-flex items-center gap-2 px-6 py-3 border-2 border-[#131132] text-[#131132] font-semibold rounded-lg hover:bg-[#131132] hover:text-white transition-all duration-300 group"
            data-testid="hero-contact-button"
          >
            {t('hero.cta', language)}
            <ArrowRight className="w-5 h-5 group-hover:translate-x-1 transition-transform" />
          </button>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
